import React from "react";
import { url } from "../apis/apiSetup";
import { language } from "./datatableLanguage";
import * as localforage from "localforage";
import * as $ from "jquery";
import "../css/dataTable.css";
import "datatables.net";
import "datetime-moment";
import { searchStyleRender } from "./datatableSearchStyleRender";
// import { datatableErrorHandling } from "./datatableErrorHandling";
import HasPermission from "@/components/commons/HasPermission";
import { ReactRender } from "@/components/ReactRender";
import { errorHandling } from "./errorHandling";
import dayjs from "dayjs";

export const table = async (
  t,
  device_id,
  headerData,
  stopAppHandler,
  setLoading,
  disableDetectBtn,
  data
) => {
  const token = await localforage.getItem("token");
  if (disableDetectBtn) {
    setLoading(true);
  } else {
    $("#network-speed-table").DataTable({
      serverSide: true,
      processing: true,
      language: language(t),
      searching: false,
      order: [[2, "desc"]],
      info: true,
      autoWidth: false,
      stateSave: false,
      destroy: true,
      pageLength: 10,
      ordering: true,
      ajax: {
        url: `${url}/api/v2/device/network-speed-test-datatable`,
        type: "GET",
        data: {
          device_id
        },
        beforeSend: request => {
          request.setRequestHeader("Authorization", "Bearer " + token);
          request.setRequestHeader("Accept", "application/json");
        },
        error: err => {
          errorHandling(err);
        },
        complete: () => {
          setLoading(false);
        }
      },
      columns: [
        {
          data: "download_speed_mbps",
          className: "download_speed_mbps",
          style: {marginLeft: 20},
          title: t({defaultMessage: "下载 Mbps"}),
          orderable: false,
          createdCell: (td, data) => {
            ReactRender(data? Number(data).toFixed(2): "-", td);
          }
        },
        {
          data: "upload_speed_mbps",
          className: "upload_speed_mbps",
          searchable: false,
          title: t({defaultMessage: "上传 Mbps"}),
          orderable: false,
          createdCell: (td, data) => {
            ReactRender(data? Number(data).toFixed(2): "-", td);
          }
        },
        {
          data: "created_at",
          className: "created_at",
          searchable: false,
          title: t({defaultMessage: "测速日期"}),
          createdCell: (td, data) => {
            ReactRender(
              data ? dayjs(data).format("YYYY-MM-DD HH:mm:ss") : "-",
              td
            );
          }
        },
      ]
    });
    searchStyleRender();
  }
};
